const downloadsLibraryId = 2732;
const PornhubPremiumAddonId = 5411;

export const updateContentValues = (content = {}) => {
    let collection = [...content.collection];
    const { linkQueryKey, linkType } = content;

    // PornhubPremium hardcoded value
    if (linkQueryKey === 'addon') {
        collection = collection.map(item => {
            if (item.id === PornhubPremiumAddonId) {
                return {
                    ...item,
                    linkType: 'MY_LIBRARY',
                };
            }

            return item;
        });
    }

    // The Downloads removing from purchased list
    if (linkQueryKey === 'addon') {
        collection = collection.filter(item => item.id !== downloadsLibraryId);
    }

    return {
        collection,
        linkType,
        linkQueryKey,
    };
};

export const filterByTags = (bundles, marketplaceTags = '') => {
    if (!marketplaceTags) {
        return bundles;
    }

    const tagsArr = marketplaceTags.split(';').map(Number);

    return bundles.filter(bundle => {
        if (!Array.isArray(bundle.tags)) {
            console.error('Error: the bundle does not have tags data');
            return true;
        }

        const itemTags = bundle.tags.map(tag => tag.id);
        return itemTags.some(item => tagsArr.includes(item));
    });
};

export const updateBundlesValues = (bundles = []) => bundles.map(bundle => {
    const tmpBundle = { ...bundle };

    tmpBundle.id = bundle.bundleId;

    if (bundle.bundleOperation === 'purchase') {
        tmpBundle.linkType = 'MY_LIBRARY';
    }

    return tmpBundle;
});
